/** Known Chats empty-state copy — Telethon/session only, never Bot /start guidance. */

export const KNOWN_CHATS_EMPTY_MESSAGE =
  'No known Telegram chats found. Refresh chats or make sure the Telethon session is authorized.';

export const KNOWN_CHATS_NO_CACHE_MESSAGE =
  'No cached Telegram chats yet. Click Refresh to load chats from the Telethon session.';

export type KnownChatsEmptyInput = {
  message?: string | null;
  messageCode?: string | null;
  message_code?: string | null;
  cached?: boolean | null;
  refreshing?: boolean | null;
};

function containsBotStartCopy(text: string): boolean {
  const lower = text.toLowerCase();
  return lower.includes('/start') || lower.includes('open the bot') || lower.includes('bot and send');
}

export function formatKnownChatsEmptyState(input?: KnownChatsEmptyInput | null): string {
  const code = input?.messageCode ?? input?.message_code ?? null;
  if (code === 'telethon_no_known_chats') {
    return KNOWN_CHATS_EMPTY_MESSAGE;
  }
  if (code === 'telethon_no_cached_chats') {
    return KNOWN_CHATS_NO_CACHE_MESSAGE;
  }
  if (code === 'telethon_refreshing') {
    return 'Refreshing known chats from the Telethon session…';
  }
  if (code === 'telegram_not_configured') {
    return 'Telegram is not configured. Add Telethon credentials in Configuration.';
  }
  const message = input?.message?.trim();
  if (message && !containsBotStartCopy(message)) {
    return message;
  }
  if (input?.cached === false && input?.refreshing) {
    return KNOWN_CHATS_NO_CACHE_MESSAGE;
  }
  return KNOWN_CHATS_EMPTY_MESSAGE;
}
